import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import dashboardRoutes from './dashboard';
import trainerRoutes from './trainer';
import journeyRoutes from './journey';
import pokedexRoutes from './pokedex';
import loginRoutes from './login';
import pvpRoutes from './pvp';
import messagesRoutes from './messages';
import tradeRoutes from './trade';

Vue.use(VueRouter);

const routes = [
    ...dashboardRoutes,
    ...trainerRoutes,
    ...journeyRoutes,
    ...pokedexRoutes,
    ...loginRoutes,
    ...pvpRoutes,
    ...messagesRoutes,
    ...tradeRoutes,
    {
        path: '/',
        redirect: '/journey'
    },
    // Catch-all - presmerovava na /login; beforeEach guard nize uz sam posle
    // prihlaseneho uzivatele dal na Journey.
    {
        path: '*',
        redirect: '/login'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    const tokenExists = !!store.state.user.token;

    if (!tokenExists && to.name !== 'Login') {
        next({ name: 'Login' });
    }
    else if (tokenExists && to.name === 'Login') {
        next({ name: 'Journey' });
    }
    else {
        next();
    }
});

export default router;